"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SongManager = void 0;
const tsyringe_1 = require("tsyringe");
const MMMConfigurationDatabase_1 = require("../configuration/indexDb/MMMConfigurationDatabase");
let SongManager = class SongManager {
    constructor(db) {
        this.db = db;
    }
    addSong(song) {
        return __awaiter(this, void 0, void 0, function* () {
            let newSongId = yield this.db.song.add(song);
            return yield this.db.song.get(newSongId);
        });
    }
    switchSong(songId) {
        return __awaiter(this, void 0, void 0, function* () {
            this.currentSong = yield this.db.song.get(songId);
            if (this.songSwitched != null)
                yield this.songSwitched(this.currentSong);
        });
    }
    getSongs() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.db.song.toArray();
        });
    }
    getSongById(songId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.db.song.get(songId);
        });
    }
    deleteSongById(songId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.db.song.delete(songId);
        });
    }
    putSong(songId, newSong) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.db.song.put(newSong, songId);
        });
    }
    songToJson(songId) {
        return __awaiter(this, void 0, void 0, function* () {
            let song = yield this.getSongById(songId);
            return JSON.stringify(song);
        });
    }
    jsonToSong(jsonText) {
        return __awaiter(this, void 0, void 0, function* () {
            let jsonObject = JSON.parse(jsonText);
            let song = {
                name: jsonObject.name,
                artist: jsonObject.artist,
                dateAdded: new Date(Date.now()),
                bannerImageUrl: jsonObject.bannerImageUrl,
                audioStreamResourceId: jsonObject.audioStreamResourceId,
                pluginsUsed: jsonObject.pluginsUsed,
                additionalMetadata: jsonObject.additionalMetadata
            };
            return yield this.addSong(song);
        });
    }
};
SongManager = __decorate([
    tsyringe_1.injectable(),
    __metadata("design:paramtypes", [MMMConfigurationDatabase_1.MMMConfigurationDatabase])
], SongManager);
exports.SongManager = SongManager;
//# sourceMappingURL=SongManager.js.map